import { render } from "./CuentasBancariasCrearActualizarComponent.vue?vue&type=template&id=5f27b344"
import script from "./CuentasBancariasCrearActualizarComponent.vue?vue&type=script&lang=js"
export * from "./CuentasBancariasCrearActualizarComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/tesoreria_tolima/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__